import { render, staticRenderFns } from "./Relevance.vue?vue&type=template&id=59882c90&scoped=true"
import script from "./Relevance.vue?vue&type=script&lang=js"
export * from "./Relevance.vue?vue&type=script&lang=js"
import style0 from "./Relevance.vue?vue&type=style&index=0&id=59882c90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59882c90",
  null
  
)

export default component.exports